<template>
  <hic-dialog append-to-body title="模块编辑" :visible="visible" @close="cancel" top="4vh" width="90%" @open="open" :close-on-click-modal="false">
    <el-form v-loading="meta.loading" :model="value" :rules="comRules" ref="submitForm" label-width="6rem" label-position="right" style="padding-right: 3rem" size="mini">
      <el-row>
        <el-col :span="6">
          <el-form-item label="编码" prop="code">
            <el-tag v-if="value.id" style="width: 100%">
              <b>{{ value.code }}</b>
            </el-tag>
            <el-input v-else size="small" type="text" placeholder="请输入编码" v-model.trim="value.code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="名称" prop="name">
            <el-input size="small" type="text" placeholder="请输入名称" v-model.trim="value.name" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="角色限制" prop="" title="选择当前模块允许浏览的角色，保持空则允许所有人浏览">
            <el-select size="small" v-model="rolesSelect" placeholder="选择当前页面允许浏览的角色，保持空则允许所有人浏览" multiple value-key="id" style="width: 100%" clearable>
              <el-option v-for="(item, index) in userRoles" :key="index + 50" :label="item.name" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="参数" prop="params">
            <el-input size="small" type="text" placeholder="请输入参数" v-model.trim="value.params" />
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="说明" prop="">
            <el-input type="textarea" :rows="1" v-model="value.memo" placeholder="请输入说明" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-collapse v-model="activeNames">
        <el-collapse-item title="" :name="1">
          <template slot="title">
            <b slot="title">数据查询： </b>
          </template>
          <el-tabs tab-position="top" type="border-card">
            <el-tab-pane label="数据源">
              <el-checkbox v-model="value.ignoreSql" class="left-pad">省略</el-checkbox>
              <el-row v-if="!value.ignoreSql">
                <el-row v-for="(item, index) in mainSqls" :key="index">
                  <el-col :span="10">
                    <el-form-item label="数据库连接">
                      <hic-dict-selector style="width: 80%" dict-type="DataLink" placeholder="请选择数据库连接" v-model="item.code" />
                      <!-- <el-button v-if="index == 0" class="el-icon-plus left-pad" type="primary" size="small" circle plain @click="sqlOp('mainSqls', 1)"></el-button> -->
                      <!-- <el-button v-else class="el-icon-delete left-pad" type="danger" size="small" circle plain @click="sqlOp('mainSqls', 0, index)"></el-button> -->
                    </el-form-item>
                  </el-col>
                  <el-col :span="14" class="right">
                    <el-button type="danger" size="small" icon="el-icon-s-promotion" plain round @click="testSql(item)">测试</el-button>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="SQL" prop="">
                      <el-input
                        type="textarea"
                        :rows="3"
                        v-model="item.sql"
                        placeholder="请输入SQL, 变量使用 {变量名} 的形式，变量值通过画面传递，前一画面传递给后一画面。其中首页始终给下一画面传递 {keyword}。另外，{tenantId} 不需要前一画面传递，后端会自动处理：添加查询条件 tenant_id = 当前用户租户ID。"
                        size="small"
                        clearable
                      ></el-input>
                      <span v-if="index" type="warning" class="danger"> 若配置多个数据查询，需要保证所有配置中 SQL 语句返回的结构一致，最终结果将会以多个查询结果合并的形式返回</span>
                    </el-form-item>
                  </el-col>

                  <el-col :span="24">
                    <el-form-item label="返回值类型" prop="resultType">
                      <hic-dict-selector style="width: 13rem" dict-type="ResultType" placeholder="请选择" v-model="value.resultType" is-enum />
                    </el-form-item>
                  </el-col>

                  <el-col :span="24">
                    <el-form-item label="返回值结构" prop="">
                      <el-table ref="expandTable" :data="resultData" style="width: 100%" :row-class-name="getRowClassName" border>
                        <el-table-column width="1" type="expand">
                          <template>
                            <div style="padding-left: 1rem; padding-right: 1rem">
                              <el-table :data="listData" style="width: 100%" size="mini" border>
                                <el-table-column align="center" label="操作" width="120">
                                  <template #header="props">
                                    <el-button type="primary" size="mini" round plain icon="el-icon-plus" @click="sqlOp('listData', 1)">添加字段</el-button>
                                  </template>
                                  <template slot-scope="props">
                                    <el-button v-if="props.row.isEdit" type="primary" title="取消" size="mini" icon="el-icon-check" circle plain @click="edit(props.row, false)"></el-button>
                                    <el-button v-else type="primary" title="编辑" size="mini" icon="el-icon-edit" circle plain @click="edit(props.row, true)"></el-button>
                                    <el-button type="danger" title="删除" size="mini" icon="el-icon-delete" circle plain @click="sqlOp('listData', 0, props.$index)"></el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column align="left" label="字段编码" prop="">
                                  <template #default="{ row }">
                                    <div v-if="!row.isEdit">{{ row.code }}</div>
                                    <el-input v-else size="small" type="text" placeholder="请输入字段编码" v-model.trim="row.code" />
                                  </template>
                                </el-table-column>
                                <el-table-column align="left" label="字段名称" prop="name">
                                  <template #default="{ row }">
                                    <div v-if="!row.isEdit">{{ row.name }}</div>
                                    <el-input v-else size="small" type="text" placeholder="请输入名称" v-model.trim="row.name" />
                                  </template>
                                </el-table-column>
                                <el-table-column align="left" label="字段类型" prop="name">
                                  <template #default="{ row }">
                                    <div v-if="!row.isEdit">{{ row.type }}</div>
                                    <hic-dict-selector v-else dict-type="SqlItemType" placeholder="请选择字段类型" is-enum v-model="row.type" />
                                  </template>
                                </el-table-column>
                                <el-table-column align="left" label="浏览权限" prop="name" width="240px">
                                  <template #default="{ row }">
                                    <div v-if="!row.isEdit">{{ row.roles | namesFilter }}</div>
                                    <template v-else>
                                      <el-select size="small" v-model="row.roles" placeholder="请选择" multiple collapse-tags value-key="id" style="width: 100%">
                                        <el-option v-for="item in rolesSelect" :key="item.id" :label="item.name" :value="item"></el-option>
                                      </el-select>
                                    </template>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="120" key="iousCmd">
                          <template #header="props">
                            <el-button type="primary" size="small" round plain icon="el-icon-plus" @click="sqlOp('resultData', 1)">添加字段</el-button>
                          </template>
                          <template slot-scope="props">
                            <el-button v-if="props.row.isEdit" type="primary" title="取消" size="mini" icon="el-icon-check" circle plain @click="edit(props.row, false)"></el-button>
                            <el-button v-else type="primary" title="编辑" size="mini" icon="el-icon-edit" circle plain @click="edit(props.row, true)"></el-button>
                            <el-button type="danger" title="删除" size="mini" icon="el-icon-delete" circle plain @click="sqlOp('resultData', 0, props.$index)"></el-button>
                          </template>
                        </el-table-column>
                        <el-table-column align="left" label="字段编码" prop="">
                          <template #default="{ row }">
                            <div v-if="!row.isEdit">{{ row.code }}</div>
                            <el-input v-else size="small" type="text" placeholder="请输入字段编码" v-model.trim="row.code" />
                          </template>
                        </el-table-column>
                        <el-table-column align="left" label="字段名称" prop="name">
                          <template #default="{ row }">
                            <div v-if="!row.isEdit">{{ row.name }}</div>
                            <el-input v-else size="small" type="text" placeholder="请输入名称" v-model.trim="row.name" />
                          </template>
                        </el-table-column>
                        <el-table-column align="left" label="字段类型" prop="name">
                          <template #default="{ row }">
                            <div v-if="!row.isEdit">{{ row.type }}</div>
                            <hic-dict-selector v-else dict-type="SqlItemType" @change="typeChange($event, row)" placeholder="请选择字段类型" is-enum v-model="row.type" />
                          </template>
                        </el-table-column>
                        <el-table-column align="left" label="浏览权限" prop="name" width="240px">
                          <template #default="{ row }">
                            <div v-if="!row.isEdit">{{ row.roles | namesFilter }}</div>
                            <template v-else>
                              <el-select size="small" v-model="row.roles" placeholder="请选择" multiple collapse-tags value-key="id" style="width: 100%">
                                <el-option v-for="item in rolesSelect" :key="item.id" :label="item.name" :value="item"></el-option>
                              </el-select>
                            </template>
                          </template>
                        </el-table-column>
                      </el-table>
                      <!-- <el-row v-if="this.value.resultType == '列表' || this.value.resultType == '分页列表'" class="mt10">
                  <el-col :span="8">
                    <el-form-item label="列表项" prop="">
                      <el-select size="small" v-model="resutObj.fields" placeholder="请选择" @change="addItems($event, 'fields')">
                        <el-option v-for="(item, index) in resultData" :key="index" :label="item.code" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="总页数" prop="">
                      <el-select size="small" v-model="resutObj.isPages" placeholder="请选择" @change="addItems($event, 'isPages')">
                        <el-option v-for="(item, index) in resultData" :key="index + 100" :label="item.code" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="总行数" prop="">
                      <el-select size="small" v-model="resutObj.isTotal" placeholder="请选择" @change="addItems($event, 'isTotal')">
                        <el-option v-for="(item, index) in resultData" :key="index + 200" :label="item.code" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="辅助数据">
              <el-row v-for="(item, index) in otherSqls" :key="index">
                <el-col :span="10">
                  <el-form-item label="数据库连接">
                    <hic-dict-selector style="width: 80%" dict-type="DataLink" placeholder="请选择数据库连接" v-model="item.db" />
                    <el-button v-if="!index" class="el-icon-plus left-pad" type="primary" size="small" circle plain @click="sqlOp('otherSqls', 1)"></el-button>
                    <el-button v-if="index" class="el-icon-delete left-pad" type="danger" size="small" circle plain @click="sqlOp('otherSqls', 0, index)"></el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="编码">
                    <el-input v-model="item.code" size="small" />
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="类型">
                    <el-select v-model="item.type" size="small">
                      <el-option label="字典" value="字典"></el-option>
                      <el-option label="数据对象" value="数据对象"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" class="right">
                  <el-button type="danger" size="small" icon="el-icon-s-promotion" plain round @click="testSql(item)">测试</el-button>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="SQL" prop="">
                    <el-input
                      type="textarea"
                      :rows="3"
                      v-model="item.sql"
                      placeholder="请输入SQL, 变量使用 {变量名} 的形式，变量值通过画面传递，前一画面传递给后一画面。其中首页始终给下一画面传递 {keyword}。另外，{tenantId} 不需要前一画面传递，后端会自动处理：添加查询条件 tenant_id = 当前用户租户ID。"
                      size="small"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-collapse-item>
        <el-collapse-item title="" :name="2">
          <template slot="title">
            <b slot="title">模板脚本： </b>
          </template>
          <el-tabs tab-position="top" type="border-card">
            <el-tab-pane label="模板">
              <el-row type="flex" class="bottom-pad" justify="space-between">
                <div>
                  <el-popover placement="top-start" title="例子：" trigger="click">
                    <pre>{{ originTempleta }}</pre>
                    <el-button slot="reference" type="success" size="small" icon="el-icon-apple">语法参考</el-button>
                  </el-popover>
                </div>
                <div class="right">
                  <el-button v-if="this.value.resultType == '列表' || this.value.resultType == '分页列表'" type="primary" @click="genTableHtml" size="small" icon="el-icon-s-fold">生成表格</el-button>
                  <el-button type="primary" @click="genTextHtml" size="small" icon="el-icon-menu">生成文本块</el-button>
                  <el-button type="danger" @click="testModel" size="small" icon="el-icon-data-board">预览</el-button>
                </div>
              </el-row>
              <div>
                <el-input type="textarea" :rows="10" v-model="value.content" placeholder="" size="small" clearable></el-input>
              </div>
            </el-tab-pane>
            <el-tab-pane label="脚本">
              <el-row class="right bottom-pad">
                <el-button type="primary" @click="genJs" size="small" icon="el-icon-menu">生成框架</el-button>
              </el-row>
              <div>
                <el-input type="textarea" :rows="10" v-model="value.js" placeholder="" size="small" clearable></el-input>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <Module v-if="meta.showModuld" v-model="value" :paras="moduleParas" />

    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button :loading="meta.loading" type="warning" @click="save(false)">暂 存</el-button>
      <el-button :loading="meta.loading" type="primary" @click="save(true)">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      type: String,
      visible: Boolean,
      value: Object,
    },
    components: {
      Module: () => import("@/components/dynamic/module"),
    },
    data() {
      return {
        rolesSelect: [],
        userRoles: [],
        meta: {
          loading: false,
          showModuld: false,
        },
        activeNames: [2],
        mainSqls: [{ code: null, sql: null }],
        otherSqls: [{ db: null, code: null, sql: null, type: null }],
        comRules: {
          code: [{ required: true, message: "请输入编码", trigger: "blur" }],
          needPaging: [{ required: true, message: "请输入连接字符串", trigger: "blur" }],
          isMultiDb: [{ required: true, message: "请选择是否多表", trigger: "change" }],
          isMultiDbUnion: [{ required: true, message: "请选择表间关系", trigger: "change" }],
          resultType: [{ required: true, message: "请选择数据类型", trigger: "change" }],
        },
        resultData: [],
        listData: [],
        resutObj: {},
        moduleParas: {},
        originTempleta:
          "显示原始数据： \n " +
          "{{ data }} \n " +
          "对象展示： \n " +
          '<el-descriptions title="患者基本信息" :column="4"> \n ' +
          '  <el-descriptions-item label="编码">{{data.items[0].code}}</el-descriptions-item> \n ' +
          '  <el-descriptions-item label="姓名">{{data.items[0].name}}</el-descriptions-item> \n ' +
          "</el-descriptions> \n " +
          "列表展示： \n " +
          '<el-table :data="data.items"> \n ' +
          '  <el-table-column label="编码" prop="code"/> \n ' +
          '  <el-table-column label="姓名" prop="name"/> \n ' +
          '  <el-table-column label="年龄" prop="age" align="right"/> \n ' +
          '  <el-table-column label="性别" prop="gender" align="center"> \n ' +
          '    <template #default="{row}"> \n ' +
          '      {{row.gender | dictText("Gender")}} \n ' +
          "    </template> \n " +
          "  </el-table-column> \n " +
          '</el-table"> \n ' +
          "分页： \n " +
          '<el-row class="center"> \n' +
          '  <hic-paging :entities="data" :condition="con" @load="page" /> \n' +
          "</el-row> \n" +
          '链接跳转：(如果链接需要弹出新画面在下面标签中添加属性 target="_blank) \n ' +
          '<router-link :to="{ name:\'dynamic\',query:{code:目标页面编码, paras: 参数JSON字符串} }" class="primary" >{{row.name}}</router-link> \n' +
          "面包屑： \n " +
          '<el-row type="flex" justify="space-between" align="middle"> \n ' +
          '  <el-breadcrumb  separator-class="el-icon-arrow-right"> \n ' +
          `    <el-breadcrumb-item :to="{ path: ' / ' }">首页</el-breadcrumb-item> \n ` +
          "    <el-breadcrumb-item>患者详情</el-breadcrumb-item> \n " +
          "  </el-breadcrumb> \n " +
          '  <el-button @click="$router.back()" type="primary" round size="mini" plain icon="el-icon-back">后退</el-button> \n ' +
          "</el-row> \n " +
          "<br/> \n ",
      };
    },
    computed: {
      ...mapGetters(["dict", "user", "dictEnum", "Enum"]),
      paras() {
        let paras = [];
        this.mainSqls.forEach((item) => {
          if (/{.*?}/.test(item.sql)) {
            paras.push(...item.sql.match(/{.*?}/g));
          }
        });
        let obj = {};
        paras.forEach((key) => {
          obj[key.replace(/{|}/g, "")] = null;
        });
        delete obj.tenantId;
        return obj;
      },
    },
    watch: {
      resultData: {
        handler(newName, oldName) {},
      },
    },
    filters: {
      namesFilter(val) {
        try {
          if (!val) return "";
          let list = val.map((el) => {
            return el.name;
          });
          return list.join(",");
        } catch (error) {
          return val;
        }
      },
    },
    created() {
      api.Role.query({})
        .then((res) => {
          this.userRoles = res.items.map((i) => ({ id: i.id, code: i.code, name: i.name }));
        })
        .catch((err) => {
          this.$message.error(err);
          this.meta.loading = false;
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
    methods: {
      open() {
        try {
          this.$refs.submitForm.resetFields();
        } catch (error) {}
        this.$set(this, "rolesSelect", []);
        this.$set(this, "mainSqls", [{ code: null, sql: null }]);
        this.$set(this, "otherSqls", [{ db: null, code: null, sql: null, type: null }]);
        this.$set(this, "resultData", []);
        this.$set(this, "listData", []);
        this.$set(this, "resutObj", {});

        if (this.value.roles) {
          this.$set(this, "rolesSelect", JSON.parse(this.value.roles));
        }

        this.value.indexStart = !!this.value.indexStart; // ? 1 : 0

        if (!this.value.dbSql || this.value.dbSql == "ignore") {
          this.$set(this.value, "ignoreSql", true);
        } else {
          this.$set(this.value, "ignoreSql", false);
          this.$set(this, "mainSqls", JSON.parse(this.value.dbSql));
        }
        if (this.value.extraSql) {
          this.$set(this, "otherSqls", JSON.parse(this.value.extraSql));
        }
        let _index = -1;
        if (this.value.resultStruct) {
          let _obj = JSON.parse(this.value.resultStruct);
          this.$set(this, "resultData", _obj.props);
          this.resultData.forEach((el, index) => {
            el.isEdit = false;
            if (el.type == "list") {
              _index = index;
              el.fields.forEach((_ele) => {
                _ele.isEdit = false;
              });
              this.$set(this, "listData", el.fields || []);
              this.$set(this.resutObj, "fields", el.code);
            }
            if (el.isTotal) this.$set(this.resutObj, "isTotal", el.code);

            if (el.isPages) this.$set(this.resutObj, "isPages", el.code);
          });
        }

        this.$nextTick(() => {
          if (_index > -1) this.$refs.expandTable.toggleRowExpansion(this.resultData[_index], true);
        });
      },
      sqlOp(objKey, v, _index) {
        if (v == 1) {
          let lastObj = this[objKey][this[objKey].length - 1];
          if (objKey == "mainSqls") {
            if (!lastObj.code || !lastObj.sql) return this.$message.error("请将信息填写完整");
            this[objKey].push({ code: "", sql: "" });
          }
          if (objKey == "otherSqls") {
            if (!lastObj.code || !lastObj.sql || lastObj.db || !lastObj.type) return this.$message.error("请将信息填写完整");
            this[objKey].push({ db: "", code: "", type: "", sql: "" });
          }
          if (objKey == "resultData" || objKey == "listData") {
            if (lastObj && (!lastObj.code || !lastObj.name || !lastObj.type || !lastObj.roles)) return this.$message.error("请将信息填写完整");
            this[objKey].push({ code: "", name: "", type: "", roles: null, isEdit: true });
          }
        } else {
          this[objKey].splice(_index, 1);
        }
        if (objKey == "resultData") {
          this.$nextTick(() => {
            this.resultData.forEach((el, index) => {
              if (el.type == "list") {
                this.$refs.expandTable.toggleRowExpansion(this.resultData[index], true);
              }
            });
          });
        }
      },
      typeChange(val, row) {
        if (val == "list") {
          this.resultData.forEach((el) => {
            if (el.type == "list") {
              this.listData = [];
              if (el.code == row.code) this.$refs.expandTable.toggleRowExpansion(el, true);
              else {
                this.$refs.expandTable.toggleRowExpansion(el, false);
              }
            }
          });
        }
      },
      addItems(val, key) {
        for (var i in this.resutObj) {
          if (key != i && this.resutObj[i] == val) {
            this.resutObj[key] = "";
            return this.$message.error("该字段已被选中");
          }
        }
        this.resultData.forEach((el) => {
          if (el.code == val) {
            if (el[key]) delete el[key];

            if (key == "fields" && !el[key]) el[key] = [];
            else el[key] = true;
          }
        });
      },

      save(ifClose) {
        this.$refs.submitForm.validate().then((valid) => {
          if (valid) {
            this.value.needPaging = !!this.value.needPaging;
            this.value.indexStart = this.value.indexStart ? 1 : 0;
            this.value.isMultiDb = !!this.value.isMultiDb;
            this.value.isMultiDbUnion = !!this.value.isMultiDbUnion;

            if (this.value.ignoreSql) {
              this.$set(this.value, "dbSql", "ignore");
            } else {
              let list = this.mainSqls.filter((el) => {
                return el.code && el.sql;
              });
              if (list.length == 0) return this.$message.error("数据查询中缺少数据源配置！");
              this.$set(this.value, "dbSql", JSON.stringify(list));
            }

            let oList = this.otherSqls.filter((el) => el.code && el.sql && el.db && el.type);
            if (oList.length) {
              this.$set(this.value, "extraSql", JSON.stringify(oList));
            }

            // if (this.resultData.length == 0) return this.$message.error("请填写返回数据结构");
            if (!this.value.content) return this.$message.error("模板内容不能为空");

            this.resultData.forEach((el) => {
              if (el.type == "list") {
                el.fields = this.listData;
              }
            });
            let par = {
              props: this.resultData,
            };
            this.$set(this.value, "resultStruct", JSON.stringify(par));

            if (this.rolesSelect) this.$set(this.value, "roles", JSON.stringify(this.rolesSelect));
            else this.$set(this.value, "roles", "[]");

            this.meta.loading = true;
            api.Module.save(this.value)
              .then((res) => {
                this.$message.success("保存成功!");
                this.value.id = res.id;
                this.value.lockKey = res.lockKey;
                this.$emit("ok", res);
                if (ifClose) {
                  this.cancel();
                }
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          }
        });
      },
      genTableHtml() {
        let htmlVal = "";
        let list = [];
        if (this.value.resultType == "列表") {
          list = this.resultData;
        } else if (this.value.resultType == "分页列表") {
          list = this.listData;
        } else {
          return;
        }

        htmlVal += `<el-table :data="data.items">\r`;
        list.forEach((el) => {
          htmlVal += `  <el-table-column label="${el.name}" prop="${el.code}"/>\r`;
        });
        htmlVal += '</el-table">\r';

        htmlVal += `<el-row class="center" >\r`;
        htmlVal += `  <hic-paging :entities="data" :condition="con" @load="page" />\r`;
        htmlVal += `</el-row>\r`;

        this.$set(this.value, "content", this.value.content + "\n" + htmlVal);
      },
      genTextHtml() {
        let htmlVal = "";

        let list = this.resultData;
        htmlVal += `<el-descriptions title="${this.value.name}" :column="4">\r`;

        let itemString = this.value.resultType == "对象" ? "" : "items[0].";

        list.forEach((el) => {
          htmlVal += `  <el-descriptions-item label="${el.name}">{{data.${itemString}${el.code}}}</el-descriptions-item>\r`;
        });
        htmlVal += `</el-descriptions>`;

        this.$set(this.value, "content", this.value.content + "\n" + htmlVal);
      },
      genJs() {
        let htmlVal = "{\r";
        htmlVal += "  dict: {},\r";
        htmlVal += "  init: (sopce) => {},\r";
        htmlVal += "  pageInit: (scope) => {},\r";
        htmlVal += "  pageBefore: (para) => {},\r";
        htmlVal += "  pageAfter: (res) => {}\r";
        htmlVal += "}\r";

        this.$set(this.value, "js", htmlVal);
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      delItem(index) {
        this.detailList.splice(index, 1);
      },
      edit(row, sta) {
        row.isEdit = sta;
        // this.$refs.expandTable.toggleRowExpansion(row, !!zk)
      },
      //获取当前行的样式
      getRowClassName({ row, rowIndex }) {
        let classname = "autofix-table-row ";
        // 通过判断给不需要展开行功能的数据设置样式，通过样式去隐藏展开行图标
        // if (row.code != '220720005') {
        // console.log(row.code, 'row.coderow.code');
        classname += " hide-expand";
        // }
        // console.log('classname==========', classname)
        return classname;
      },
      // 点击行触发并调用 toggleRowExpansion 方法
      toggleRowExpansion(row) {
        // console.log(row, 334);
        // 符合条件的才触发toggleRowExpansion方法
        // if (row.code == '220720005') {
        //   this.$refs.autofixElTable.toggleRowExpansion(row, row.expanded);
        // }
      },
      testSql(item) {
        if (!item.sql) {
          return;
        }
        this.$prompt("参数", "请设置", { inputValue: JSON.stringify(this.paras) }).then(({ value }) => {
          let obj = JSON.parse(value);
          let para = {
            dbSqls: [item],
            resultType: this.value.resultType,
            indexStart: 1,
            param: {
              pageSize: 1,
              pageIndex: 20,
            },
          };
          Object.assign(para.param, obj);
          api.Module.execSql(para)
            .then((res) => {
              this.$message.success("通过");
              console.log(res);
            })
            .catch((err) => {
              this.$message.error("异常");
              console.log(err);
            });
        });
      },
      testModel() {
        if (this.meta.showModuld) {
          this.meta.showModuld = false;
          return;
        }
        this.$prompt("参数", "请设置", { inputValue: JSON.stringify(this.paras) }).then(({ value }) => {
          this.meta.showModuld = true;
          this.moduleParas = JSON.parse(value);
        });
      },
    },
  };
</script>
<style>
  .hide-expand .el-table__expand-column .cell {
    visibility: hidden;
  }
  .hide-expand .el-table__expand-column {
    width: 10px;
    /* display: none; */
  }
</style>
